const mutations = {
  mutationSnackBar(state, payload) {
    state.snackbar = payload;
  },

  mutationModal(state, payload) {
    state.modal = payload;
  },

  mutationPageInfo(state, payload) {
    state.pageInfo = payload;
  },

  mutationProfileMenu(state, payload) {
    state.profileMenu = payload;
  },

  mutationItemListingOrganisation(state, payload) {
    state.itemListingOrganisation = payload;
  },

  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },

  mutationRouteViewKey(state, payload) {
    state.routeViewKey = payload;
  },

  mutationPageLoadingFirstTime(state, payload) {
    state.pageLoadingFirstTime = payload;
  },

  mutationRouteOnChanged(state, payload) {
    state.routeOnChanged = payload;
  },
};

export default mutations;
